import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import AuthService from "../../../services/authService";
import UserService from "../../../services/userService";
import ESignViewer from "./ESignViewer";

type Document = { documentId: string; documentName: string };
const SignDocuments = (props: { handleClose: () => void }) => {
  const patientId: string = AuthService.getAuth()?.user?.id;
  const [documentIds, setDocumentsIds] = useState<string[]>([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    UserService.getDocumentsRequiringSignature({ patientId })
      .then((res) => {
        const data: Document[] = res.data || [];
        const documents = (data || []).map((doc) => doc.documentId);
        setDocumentsIds(documents);
      })
      .catch((e) => toast.error("We are unable to get the document"))
      .finally(() => setLoading(false));
  }, []);

  const handleNextDocument = () => {
    if (documentIds.length - 1 === index) {
      props.handleClose();
    } else setIndex((prev) => prev + 1);
  };

  return (
    <ESignViewer
      loading={loading}
      showERSD="once"
      onClose={() => props.handleClose()}
      documentId={documentIds[index]}
      title={`Documents: ${index + 1} of ${documentIds.length}`}
      onSigned={() => handleNextDocument()}
    />
  );
};

export default SignDocuments;
